<template>
    <div v-if="!isCustomerSupport()">
        <div class="header">
            <span class="title">{{ config.name }}</span>
            <span class="buttons">
                <div v-if="!tableFilterVisible && showTableFilter">
                    <el-tag
                        v-for="(value, key) in tableFilter"
                        v-if="value"
                        :key="key"
                        closable
                        type="info"
                        @close="removeTableFilter(key)"
                    >
                        {{ getFilterLabel(key) }}:
                        {{
                            key === 'country_id'
                                ? getFilterCountryName(value)
                                : key === 'origin_id'
                                ? getFilterOriginName(value)
                                : value
                        }}
                    </el-tag>
                </div>

                <el-button v-if="showRefreshButton" @click="refresh"
                    ><i class="el-icon-refresh"></i
                ></el-button>

                <el-button
                    v-if="
                        config.shippedMultiselect &&
                        multipleSelection.length > 0
                    "
                    @click="setShippedStatus()"
                >
                    Set Shipped Status
                </el-button>

                <el-form ref="tableFilter" :model="tableFilter">
                    <el-popover
                        v-if="showTableFilter"
                        placement="bottom"
                        width="250"
                        trigger="manual"
                        v-model="tableFilterVisible"
                    >
                        <el-form-item
                            v-if="
                                origins.length &&
                                isCustomersRoute() &&
                                isVisible
                            "
                        >
                            <el-select
                                v-model="tableFilter.origin_id"
                                placeholder="Filter origin"
                            >
                                <el-option
                                    v-for="origin in origins"
                                    :key="origin.name"
                                    :label="origin.name"
                                    :value="origin.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item
                            v-if="
                                activeCountries.length &&
                                !isUsUser() &&
                                !isBrUser() &&
                                !isUkUser() &&
                                isOrdersRoute()
                            "
                        >
                            <el-select
                                v-model="tableFilter.country_id"
                                placeholder="Filter country"
                            >
                                <el-option
                                    v-for="country in activeCountries"
                                    :key="country.name"
                                    :label="country.name"
                                    :value="country.country_id"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="showFilterStatus !== false">
                            <el-select
                                v-model="tableFilter.status"
                                placeholder="Filter status"
                                @change="onStatusChange($event)"
                            >
                                <el-option
                                    v-for="status in statusOptions"
                                    :key="status"
                                    :label="status"
                                    :value="status"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="showFilterOrderDates !== false">
                            <el-date-picker
                                type="date"
                                placeholder="Orders From"
                                value-format="yyyy-MM-dd"
                                v-model="tableFilter.ordersFrom"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item v-if="showFilterOrderDates !== false">
                            <el-date-picker
                                type="date"
                                placeholder="Orders To"
                                value-format="yyyy-MM-dd"
                                v-model="tableFilter.ordersTo"
                            ></el-date-picker>
                        </el-form-item>

                        <el-form-item>
                            <el-button @click="resetForm('tableFilter')"
                                >Reset</el-button
                            >
                            <el-button type="primary" @click="filterSearch"
                                >Search</el-button
                            >
                        </el-form-item>

                        <el-button
                            slot="reference"
                            @click="tableFilterVisible = !tableFilterVisible"
                            >Filter
                            <span v-if="cntFiltersOptions > 0"
                                >({{ cntFiltersOptions }})</span
                            ></el-button
                        >
                    </el-popover>
                </el-form>
                <div v-if="isSearchVisible()">
                    <el-input
                        placeholder="Search"
                        suffix-icon="el-icon-search"
                        v-model="term"
                    >
                    </el-input>
                </div>
                <div class="upload-btn" v-if="config.import">
                    <el-upload
                        ref="upload"
                        :action="importEndpoint"
                        :headers="rootConfig.headers"
                        :before-upload="beforeUpload"
                        :show-file-list="true"
                        :multiple="true"
                        :on-success="handleUploadSuccess"
                        :on-error="handleUploadError"
                        v-loading="uploading"
                    >
                        <el-button slot="trigger">Import</el-button>
                    </el-upload>
                    <el-button @click="clearImport" v-if="showClearBtn"
                        >Clear</el-button
                    >
                </div>

                <el-button
                    v-loading="exporting"
                    v-if="config.exportable"
                    @click="doExport"
                >
                    Export
                </el-button>
                <el-button
                    v-if="!config.hideCreate"
                    @click="
                        $router.push({
                            name: 'admin',
                            params: {
                                model: config.route,
                                id: 'all',
                                action: 'new',
                            },
                        })
                    "
                >
                    New
                </el-button>

                <el-popover placement="bottom" width="250" trigger="click">
                    <div>
                        <el-checkbox-group
                            v-model="selectedVisibleColumns"
                            class="el-checkbox-group"
                        >
                            <div
                                v-for="column in config.columns"
                                :key="column.property"
                            >
                                <el-checkbox
                                    :label="column.property"
                                    :key="column.property"
                                    >{{ column.label }}</el-checkbox
                                >
                            </div>
                        </el-checkbox-group>

                        <el-button @click="resetFormVisibleColumns()"
                            >Reset</el-button
                        >
                        <el-button type="primary" @click="saveVisibleColumns()"
                            >Save</el-button
                        >
                    </div>
                    <el-button slot="reference">Column Settings</el-button>
                </el-popover>
            </span>
        </div>
        <div class="selection" v-if="multipleSelection.length > 0">
            <div class="selection__button">
                <el-button @click="massDeletion">Delete</el-button>
            </div>
            <span class="selection__text"
                >{{ multipleSelection.length }} selected</span
            >
        </div>

        <div
            class="mb-8"
            v-if="
                isCategoriesRoute() &&
                multipleSelection.length === 0 &&
                isVisible
            "
        >
            <el-button @click="onToggleSortCategories()">
                Sort categories
            </el-button>
            <div
                class="component-example border border-gray-500 rounded border-solid p-4 mt-4 bg-white"
                v-if="showSortCategories"
            >
                <vue-nestable v-model="nestedTableData">
                    <vue-nestable-handle slot-scope="{ item }" :item="item">
                        {{ item.name }}
                    </vue-nestable-handle>
                </vue-nestable>
                <div class="mt-4 flex">
                    <el-button
                        class="el-button--primary mt-4"
                        @click="onSaveSortCategories()"
                    >
                        Save
                    </el-button>
                    <el-button class="mt-4" @click="onCancelSortCategories()">
                        Cancel
                    </el-button>
                </div>
            </div>
        </div>

        <el-table
            @sort-change="sortChange"
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
            @row-click="handleRowClick"
            @selection-change="handleSelectionChange"
            stripe
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
                :sortable="isSortable(column.property)"
                :key="column.property"
                :label="column.label"
                :prop="column.property"
                :width="column.width"
                v-for="column in getVisibleColumns"
            >
                <template slot-scope="{ row }">
                    <span
                        v-if="column.property === 'total'"
                        :is="column.component"
                        :value="
                            row[column.property] | currency(row.currency + ' ')
                        "
                    ></span>
                    <span
                        v-else
                        :is="column.component"
                        :value="getTranslation(row[column.property])"
                        :class="
                            getColumnClasses(
                                column.property,
                                row[column.property]
                            )
                        "
                    ></span>
                </template>
            </el-table-column>
        </el-table>

        <div class="footer" v-if="pageSize > 0">
            <el-pagination
                layout="prev, pager, next"
                :total="numFound"
                :page-size="pageSize"
                :current-page="page"
                @current-change="onPageChange"
            >
            </el-pagination>
        </div>
    </div>
    <div v-else>
      <p>Voucher Code:</p>
      <p>
        <strong>{{ customerSupportCoupon }}</strong>
      </p>
      <el-button
          @click="
              $router.push({
                  name: 'admin',
                  params: {
                      model: config.route,
                      id: 'all',
                      action: 'new',
                  },
              })
          "
      >
          Generate new
      </el-button>
    </div>
</template>

<script>
import { VueNestable, VueNestableHandle } from 'vue-nestable';
import api from '../libs/api';
import download from '../libs/download';
import encryptStorage from '../libs/encryptStorage';
import storage from '../libs/storage';
import Boolean from './Boolean.vue';
import Currency from './Currency.vue';
import DateTime from './DateTime.vue';
import SimpleText from './SimpleText.vue';

export default {
    name: 'v-crud-index',

    props: ['config', 'rootConfig', 'api', 'siteId', 'permittedSitesConfig'],

    components: {
        SimpleText,
        Currency,
        Boolean,
        DateTime,
        VueNestable,
        VueNestableHandle,
    },

    data() {
        return {
            tableData: [],
            nestedTableData: [],
            multipleSelection: [],
            pageSize: 0,
            numFound: 0,
            page: 1,
            loading: false,
            term: '',
            sortProp: '',
            sort: '',
            showClearBtn: false,
            throttleCount: 0,
            throttleCountOrderDetail: 0,
            uploading: false,
            exporting: false,
            tableFilter: {
                country_id: '',
                status: '',
                ordersFrom: '',
                ordersTo: '',
                origin_id: '',
            },
            tableFilterVisible: false,
            showFilterOrderDates: false,
            showFilterStatus: false,
            statusOptions: [
                'all',
                'open',
                'cancelled',
                'delivered',
                'processing',
                'shipped',
                'pending',
            ],
            selectedVisibleColumns: [],
            activeCountries: [],
            origins: [],
            translations: null,
            showSortCategories: false,
            userRole: encryptStorage.getItem('ur'),
            customerSupportCoupon: '',
        };
    },

    async mounted() {
      if (this.isCustomerSupport()) {
          this.loadCustomerSupportData();
      } else {
          this.loadTranslations();
          this.setFiltersOptions();
          this.handleCurrentPage(this.$route.query);
          this.setVisibleColumns();

          await this.getActiveCountriesData();
          await this.getOriginsData();
          this.loadData();
      }
    },

    watch: {
        config() {
            this.setVisibleColumns();
            this.loadData();

            if (typeof this.$refs.upload !== 'undefined') {
                this.clearImport();
            }
        },

        $route(to, from) {
            this.handleCurrentPage(to.query);
            const filters = storage.getItem(storage.keys.TABLE_FILTER);
            if (to.path !== from.path && filters) {
                this.resetForm('tableFilter');
            }
        },

        term() {
            this.loadData();
        },
    },

    computed: {
        shopIsPlusCity() {
            return this.siteId === '1' || this.siteId === '50';
        },
        isVisible() {
            let site_id = this.siteId;

            if (!this.permittedSitesConfig) {
                return false;
            }

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig[`${site_id}`];
            }

            return Object.values(this.permittedSitesConfig).includes(
                Number(site_id)
            );
        },
        importEndpoint() {
            return this.rootConfig.endPoint + '/' + this.config.import;
        },

        getActiveCountries() {
            return this.$resource(
                this.rootConfig.endPoint + '/site_countries',
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },

        getOrigins() {
            return this.$resource(
                this.rootConfig.endPoint + '/origins',
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },

        filter() {
            if (
                typeof this.config.filter !== 'undefined' &&
                this.config.filter.length > 0
            ) {
                return this.config.filter + this.$route.params.id;
            }
            return '';
        },

        apiResource() {
            return this.$resource(
                this.rootConfig.endPoint +
                    '/' +
                    this.config.resource +
                    this.filter,
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },

        showTableFilter() {
            return (
                this.showFilterOrderDates !== false ||
                this.showFilterStatus !== false ||
                (this.isCustomersRoute() &&
                    this.origins.length &&
                    this.isVisible)
            );
        },

        showRefreshButton() {
            return this.config.route === 'orders';
        },

        cntFiltersOptions() {
            return Object.values(this.tableFilter).filter((value) => !!value)
                .length;
        },

        getActiveFilters() {
            return Object.entries(this.tableFilter).filter(
                ([key, value]) => !!value
            );
        },

        getVisibleColumns() {
            this.selectedVisibleColumns;
            if (
                typeof this.config.columns !== 'undefined' &&
                this.config.columns.length > 0
            ) {
                const route = this.config.route;
                const visibleColumns = this.getStoredVisibleColumns();

                if (visibleColumns[route]) {
                    return this.config.columns.filter(
                        (column) =>
                            visibleColumns[route].indexOf(column.property) >= 0
                    );
                }

                return this.config.columns;
            }
            return [];
        },
    },

    methods: {
      loadCustomerSupportData() {
          this.customerSupportCoupon = encryptStorage.getItem('customer_support_coupon'),
          encryptStorage.removeItem('customer_support_coupon');
        },
        isSortable(property) {
            if (this.config.route !== 'categories') {
                return property === 'primary_image' ? false : 'custom';
            } else {
                return false;
            }
        },
        onToggleSortCategories() {
            this.showSortCategories = !this.showSortCategories;
        },
        onCancelSortCategories() {
            this.onToggleSortCategories();
            this.loadData();
        },
        onSortCategories(categories, parentId) {
            let index = 0;
            (categories || []).forEach((category) => {
                category.parent_id = parentId;
                category.sequence = index;
                index = index + 1;
                this.onSortCategories(category.children, category.id);
            });
        },
        onFlattenCategories(categories) {
            const result = [];
            categories.forEach((category) => {
                const { id, parent_id, sequence, children } = category;
                result.push({ id, parent_id, sequence });
                if (children)
                    result.push(...this.onFlattenCategories(children));
            });
            return result;
        },
        onSaveSortCategories() {
            this.onToggleSortCategories();
            this.onSortCategories(this.nestedTableData, 0);
            const sortedCategories = this.onFlattenCategories(
                this.nestedTableData
            );
            const apiResource = this.$resource(
                this.rootConfig.endPoint + '/categories/bulk_update',
                {},
                {},
                { headers: this.rootConfig.headers }
            );
            apiResource
                .update({ changed_categories: sortedCategories })
                .then(() => {
                    this.loadData();
                })
                .catch(api.errorHandler);
        },
        isCustomersRoute() {
            return this.$route.params.model === 'customers';
        },
        isOrdersRoute() {
            return this.$route.params.model === 'orders';
        },
        isCategoriesRoute() {
            return this.$route.params.model === 'categories';
        },
        isSearchVisible() {
            return this.$route.params.model !== 'categories';
        },
        loadTranslations() {
            let datasource = this.$resource(
                'https://api.storyblok.com/v2/cdn/datasource_entries?datasource=translations'
            );

            datasource
                .get({
                    token: '7aJS9owJrpRWCa8d3iofRQtt',
                    cv: Date.now(),
                })
                .then((res) => {
                    this.translations = res.body.datasource_entries;
                });
        },

        getColumnClasses(property, value) {
            const classes = [];

            if (property === 'status') {
                classes.push('label');
                classes.push(this.getStatusColorClasses(value));
            }

            if (
                (property === 'customer_name' || property === 'email') &&
                this.isOrdersRoute() &&
                this.isVisible
            ) {
                classes.push('el-button--text cursor-pointer');
            }

            return classes;
        },

        getStatusColorClasses(status) {
            const classes = [];

            switch (status) {
                case 'Processing':
                    classes.push('label--warning');
                    break;
                case 'Shipped':
                case 'Delivered':
                    classes.push('label--success');
                    break;
                case 'On Hold':
                    classes.push('label--info');
                    break;
                case 'Cancelled':
                case 'Failed':
                case 'Payment refunded':
                case 'Not Payed':
                case 'Returned':
                    classes.push('label--danger');
                    break;
                default:
                    classes.push('label--default');
            }

            return classes;
        },

        getTranslation(key) {
            if (!this.translations) {
                return key;
            }

            const translation = this.translations.find((t) => t.name === key);

            return translation ? translation.value : key;
        },

        async getActiveCountriesData() {
            const res = await this.getActiveCountries.get();
            this.activeCountries = res.body;
        },

        async getOriginsData() {
            const res = await this.getOrigins.get();
            this.origins = res.body;
        },

        saveVisibleColumns() {
            this.selectedVisibleColumns = [...this.selectedVisibleColumns];

            const route = this.config.route;
            const storedVisibleColumns = this.getStoredVisibleColumns();
            const routeVisibleColumns = Object.assign(storedVisibleColumns, {
                [route]: this.selectedVisibleColumns,
            });

            storage.setItem(storage.keys.VISIBLE_COLUMNS, routeVisibleColumns);
        },

        resetFormVisibleColumns() {
            const route = this.config.route;
            const storedVisibleColumns = this.getStoredVisibleColumns();
            delete storedVisibleColumns[route];

            storage.setItem(storage.keys.VISIBLE_COLUMNS, storedVisibleColumns);
            this.selectedVisibleColumns = this.getColumnsProperties();
        },

        getColumnsProperties() {
            return this.config.columns.map((column) => column.property);
        },

        setVisibleColumns() {
            const route = this.config.route;
            const storedVisibleColumns = this.getStoredVisibleColumns();

            this.selectedVisibleColumns =
                storedVisibleColumns[route] || this.getColumnsProperties();
        },

        getStoredVisibleColumns() {
            return storage.getItem(storage.keys.VISIBLE_COLUMNS) || {};
        },

        sortChange(sortProps) {
            switch (sortProps.order) {
                case 'ascending':
                    this.sortProp = sortProps.prop;
                    this.sort = 'asc';
                    this.loadData();
                    break;
                case 'descending':
                    this.sortProp = sortProps.prop;
                    this.sort = 'desc';
                    this.loadData();
                    break;
                default:
                    this.sort = '';
                    this.sortProp = '';
                    this.loadData();
                    break;
            }
        },

        setShippedStatus() {
            this.multipleSelection.forEach((item, index) => {
                setTimeout(() => {
                    const apiResource = this.$resource(
                        this.rootConfig.endPoint + '/orders/' + item.id,
                        {},
                        {},
                        { headers: this.rootConfig.headers }
                    );

                    if (item.status.toLowerCase() === 'processing') {
                        apiResource
                            .update({ status: 'Shipped' })
                            .then(() => {
                                this.loadData();
                            })
                            .catch(api.errorHandler);
                    } else {
                        this.loadData();
                    }
                }, 200 * index);
            });
        },

        doExport() {
            this.exporting = true;

            if (this.config.route === 'orders') {
                this.doOrdersExport();
            } else {
                const filters = storage.getItem(storage.keys.TABLE_FILTER);
                const origin =
                    filters && filters.origin_id ? filters.origin_id : null;

                const apiParams = {
                    term: this.term,
                    per_page: 2000,
                    as_csv: true,
                };

                if (origin) {
                    apiParams.filter_origin = origin;
                }

                this.apiResource
                    .get(apiParams)
                    .then((res) => {
                        this.exporting = false;

                        if (res.data.xlsx) {
                            window.open(res.data.xlsx);
                        } else {
                            download(res.data.csv, 'entries.csv', 'text/csv');
                        }
                    })
                    .catch(() => {
                        this.exporting = false;
                    });
            }
        },

        async doOrdersExport() {
            // Load main orders
            const mainOrders = await this.loadMainOrders();

            // Load order details
            const promises = [];

            mainOrders.forEach(async (mainOrder) => {
                promises.push(this.loadOrderDetail(mainOrder.id));
            });

            const orders = await Promise.all(promises);
            this.throttleCountOrderDetail = 0;

            // Load tax categories and tax rates
            const taxCategories = await this.getTaxCategoriesMapped();

            // Make csv string

            let csvString = '';

            const columns = [
                'order_number',
                'customer_name',
                'ordered_on',
                'shipped_on',
                'status',
                'tax',
                'payment_method',
                'total',
                'subtotal',
                'orderitemscount',
                'coupon_discount',
                'shipping',
                'shipping_notes',
                'shipping_method_name',
                'currency',
                'notes',
                'customer_id',
                'email',
                'tracking_number',
                'ship_address',
                'bill_address',
                'language',
            ];

            if (this.shopIsPlusCity) {
                const orderitemscountIndex = columns.indexOf('orderitemscount');
                if (orderitemscountIndex !== -1) {
                    columns.splice(
                        orderitemscountIndex + 1,
                        0,
                        '10euro_count',
                        '50euro_count',
                        'envelope_count'
                    );
                } else {
                    columns.push(
                        '10euro_count',
                        '50euro_count',
                        'envelope_count'
                    );
                }
            }

            // Add tax categories

            let columnIndex = columns.indexOf('tax') + 1;

            Object.keys(taxCategories).forEach((taxCategoryId) => {
                const newTaxColumnName = `tax_${taxCategories[taxCategoryId]}`;

                if (columns.indexOf(newTaxColumnName) < 0) {
                    columns.splice(columnIndex, 0, newTaxColumnName);
                    columnIndex = columns.indexOf(newTaxColumnName) + 1;
                }

                const newNettoColumnName = `netto_${taxCategories[taxCategoryId]}`;

                if (columns.indexOf(newNettoColumnName) < 0) {
                    columns.splice(columnIndex, 0, newNettoColumnName);
                    columnIndex = columns.indexOf(newNettoColumnName) + 1;
                }
            });

            orders.forEach((order) => {
                const taxValues = {};
                const nettoValues = {};
                if (this.shopIsPlusCity) {
                    order['10euro_count'] = order.order_items
                        .filter((item) => item.sku === 'gutschein-10')
                        .reduce((sum, item) => sum + item.quantity, 0);
                    order['50euro_count'] = order.order_items
                        .filter((item) => item.sku === 'gutschein-50')
                        .reduce((sum, item) => sum + item.quantity, 0);
                    order['envelope_count'] = order.order_items
                        .filter((item) => item.sku === 'kuvert')
                        .reduce((sum, item) => sum + item.quantity, 0);
                }

                order.order_items.forEach((orderItem) => {
                    if (orderItem.meta_data) {
                        const taxCategoryId =
                            orderItem.meta_data.tax_category_id;

                        if (taxCategoryId !== null) {
                            if (!taxValues[taxCategoryId]) {
                                taxValues[taxCategoryId] = 0;
                            }

                            taxValues[taxCategoryId] +=
                                orderItem['total_value'];

                            if (!nettoValues[taxCategoryId]) {
                                nettoValues[taxCategoryId] = 0;
                            }

                            const taxRate = taxCategories[taxCategoryId];
                            const factor = 1 + taxRate / 100;
                            nettoValues[taxCategoryId] =
                                this.roundDecimalNumber(
                                    nettoValues[taxCategoryId] +
                                        orderItem['total_value'] / factor
                                );
                        }
                    }
                });

                Object.keys(taxValues).forEach((taxCategoryId) => {
                    const taxRate = taxCategories[taxCategoryId];
                    const factor = 1 + taxRate / 100;
                    const netto = this.roundDecimalNumber(
                        taxValues[taxCategoryId] / factor
                    );

                    order[`tax_${taxRate}`] = this.roundDecimalNumber(
                        taxValues[taxCategoryId] - netto
                    );
                    order[`netto_${taxRate}`] = nettoValues[taxCategoryId];
                });

                let orderItemsCount = 0;

                order.order_items.forEach((orderItem) => {
                    orderItemsCount += orderItem.quantity;
                });

                order['orderitemscount'] = orderItemsCount;

                // 20% tax for shipping costs
                const shippingNetto = order.shipping / 1.2;
                const shippingTax = order.shipping - shippingNetto;
                order.tax = this.roundDecimalNumber(order.tax + shippingTax);

                if (order.tax_20) {
                    order.tax_20 = this.roundDecimalNumber(
                        order.tax_20 + shippingTax
                    );
                } else {
                    order.tax_20 = this.roundDecimalNumber(shippingTax);
                }
            });

            // Flatten order object for shipping_notes, bill_address and ship_address
            const flattenColumns = [
                'shipping_notes',
                'bill_address',
                'ship_address',
            ];

            orders.forEach((order) => {
                flattenColumns.forEach((column) => {
                    let columnIndex = columns.indexOf(column) + 1;

                    if (
                        order[column] !== null &&
                        typeof order[column] === 'object'
                    ) {
                        const keys = Object.keys(order[column]);

                        keys.forEach((key) => {
                            const newColumnName = `${column}_${key}`;
                            order[newColumnName] = order[column][key];

                            if (columns.indexOf(newColumnName) < 0) {
                                columns.splice(columnIndex, 0, newColumnName);
                                columnIndex =
                                    columns.indexOf(newColumnName) + 1;
                            }
                        });
                    }
                });
            });

            // Remove flattened Columns
            flattenColumns.forEach((column) => {
                columns.splice(columns.indexOf(column), 1);
            });

            // Add header columns
            columns.forEach((column) => {
                csvString += `"${column}";`;
            });

            csvString += '\r\n';

            // Add data rows
            orders.forEach((order) => {
                columns.forEach((column) => {
                    if (
                        Object.keys(order).indexOf(column) >= 0 &&
                        order[column] !== null
                    ) {
                        if (typeof order[column] === 'object') {
                            // Escape double quotes by doubling them
                            const escaped = JSON.stringify(order[column]).replace(/"/g, '""');

                            csvString += `"${escaped}"`;
                        } else {
                            csvString += `"${order[column]}"`;
                        }
                    }

                    csvString += ';';
                });

                csvString += '\r\n';
            });

            // Download csv

            download(csvString, 'entries.csv', 'text/csv');

            this.exporting = false;
        },

        roundDecimalNumber(number) {
            return Math.round(number * 100) / 100;
        },

        getTaxCategoriesMapped() {
            return new Promise((resolve) => {
                const taxCategoriesMapped = {};

                const apiResource = this.$resource(
                    this.rootConfig.endPoint + '/tax_rates',
                    {},
                    {},
                    { headers: this.rootConfig.headers }
                );

                apiResource
                    .get()
                    .then((res) => {
                        const taxRates = res.data;

                        taxRates.forEach((taxRate) => {
                            if (
                                !taxCategoriesMapped[taxRate['tax_category_id']]
                            ) {
                                taxCategoriesMapped[
                                    taxRate['tax_category_id']
                                ] = taxRate['tax'];
                            }
                        });

                        resolve(taxCategoriesMapped);
                    })
                    .catch(api.errorHandler);
            });
        },

        loadOrderDetail(orderId) {
            return new Promise((resolve) => {
                const apiResource = this.$resource(
                    this.rootConfig.endPoint + '/orders/' + orderId,
                    {},
                    {},
                    { headers: this.rootConfig.headers }
                );

                setTimeout(() => {
                    apiResource
                        .get()
                        .then((res) => {
                            resolve(res.data);
                        })
                        .catch(api.errorHandler);
                }, this.throttleCountOrderDetail * 150);

                this.throttleCountOrderDetail =
                    this.throttleCountOrderDetail + 1;
            });
        },

        async loadMainOrders() {
            const orders = [];
            let page = 0;
            const perPage = 500;
            let total = 0;

            while (page === 0 || page * perPage < total) {
                page++;

                let options = { page, per_page: perPage };
                options = this.addFilterOptions(options);

                const res = await this.loadOrder(options);

                res.data.forEach((order) => {
                    orders.push(order);
                });

                total = this.getHeader(res, 'Total');
            }

            return orders;
        },

        loadOrder(options) {
            return new Promise((resolve) => {
                this.apiResource
                    .get(options)
                    .then(resolve)
                    .catch(api.errorHandler);
            });
        },

        beforeUpload() {
            this.uploading = true;

            return new Promise((resolve) => {
                setTimeout(resolve, this.throttleCount * 100);
                this.throttleCount = this.throttleCount + 1;
            });
        },

        pageChange(page) {
            this.page = page;
            this.$router.push({ query: { page } });
        },

        onPageChange(page) {
            this.pageChange(page);
            this.loadData();
        },

        handleUploadSuccess() {
            this.loadData();
            this.showClearBtn = true;
            this.uploading = false;

            if(window.location.host === 'wh.admin.commerce.netural.com') {
                this.clearCacheProdWH();
            } else if (window.location.host === 'qa-wh.admin.commerce.netural.com') {
                this.clearCacheQaWH();
            }
        },

        clearCacheProdWH() {
            const prodDomainsWH = {
                '42683': 'https://shop-de.wh.com',
                '42718': 'https://shop-fr.wh.com',
                '42710': 'https://shop-bg.wh.com',
                '42699': 'https://shop-au.wh.com',
                '42639': 'https://shop-ca.wh.com',
                '42730': 'https://shop-in.wh.com',
                '42737': 'https://shop-pl.wh.com',
                '42738': 'https://shop-tr.wh.com',
                '42781': 'https://shop-iberica.wh.com',
                '42839': 'https://shop-dk.wh.com',
                '42840': 'https://shop-se.wh.com',
            };

            const domain = prodDomainsWH[this.siteId];

            if (domain) {
                this.sendCacheClearRequest(domain);
            }
        },

        clearCacheQaWH() {
          const qaDomainsWH = {
                '42683': 'https://wh-shop-b2c-de-at.dev.netural.com',
                '42718': 'https://wh-shop-b2c-france.dev.netural.com',
                '42710': 'https://wh-shop-b2c-bulgaria.dev.netural.com',
                '42699': 'https://wh-shop-b2c-australia.dev.netural.com',
                '42639': 'https://wh-shop-b2c-impex.dev.netural.com',
                '42730': 'https://wh-shop-b2c-india.dev.netural.com',
                '42737': 'https://wh-shop-b2c-poland.dev.netural.com',
                '42738': 'https://wh-shop-b2c-turkiye.dev.netural.com',
                '42781': 'https://wh-shop-b2c-iberica.dev.netural.com',
                '42839': 'https://wh-shop-b2c-denmark.dev.netural.com',
                '42840': 'https://wh-shop-b2c-sweden.dev.netural.com'
            };

            const domain = qaDomainsWH[this.siteId];

            if (domain) {
                this.sendCacheClearRequest(domain);
            }
        },

        sendCacheClearRequest(domain) {
            fetch(`${domain}/clear_cache`, { mode: 'no-cors' })
                .then(() => console.log(`Cache clear request sent to ${domain}`))
                .catch(err => console.error(`Error clearing cache for ${domain}`, err));
        },

        handleUploadError(res) {
            this.handleUploadSuccess();
            let response;

            if (JSON.parse(res.message).errors) {
                response = {
                    body: JSON.parse(res.message),
                };
            } else {
                response = {
                    status: res.status,
                    body: JSON.parse(res.message.substr(4)),
                };
            }
            api.errorHandler.call(this, response);
        },

        clearImport() {
            this.$refs.upload.clearFiles();
            this.showClearBtn = false;
            this.throttleCount = 0;
        },

        loadData() {
            let options = { page: this.page, term: this.term };
            options = this.addFilterOptions(options);

            this.loading = true;
            this.apiResource
                .get(options)
                .then(this.setTableData)
                .catch(api.errorHandler);
        },

        removeTableFilter(key) {
            this.tableFilter = Object.assign(this.tableFilter, {
                [key]: '',
            });

            storage.setItem(storage.keys.TABLE_FILTER, this.tableFilter);
            this.loadData();
        },

        setFiltersOptions() {
            const filters = storage.getItem(storage.keys.TABLE_FILTER);
            this.tableFilter = Object.assign({}, this.tableFilter, filters);
        },

        addFilterOptions(options) {
            // Sort By
            const availableSortProps = this.config.columns.map(
                (c) => c.property
            );
            if (
                this.sortProp !== '' &&
                availableSortProps.includes(this.sortProp)
            ) {
                options = {
                    ...options,
                    sort_by: this.sortProp + ':' + this.sort,
                };
            }

            // Origin
            if (this.tableFilter.origin_id !== '') {
                const originId = this.tableFilter.origin_id;
                options = { ...options, filter_origin: originId };
            }

            // Country
            if (this.tableFilter.country_id !== '') {
                const countryId = this.tableFilter.country_id;
                options = { ...options, country_id: countryId };
            }

            // US User
            if (this.isUsUser()) {
                const usCountry = this.activeCountries.find(
                    (c) => c.name === 'United States'
                );
                options = { ...options, country_id: usCountry.country_id };
            } else if (this.isBrUser()) {
                const brCountry = this.activeCountries.find(
                    (c) => c.name === 'Brazil'
                );
                options = { ...options, country_id: brCountry.country_id };
            } else if (this.isUkUser()) {
                const ukCountry = this.activeCountries.find(
                    (c) => c.name === 'United Kingdom'
                );
                options = { ...options, country_id: ukCountry.country_id };
            }

            // Status
            if (this.tableFilter.status !== '') {
                const status =
                    this.tableFilter.status === 'all'
                        ? ''
                        : this.tableFilter.status;
                options = { ...options, status };
            }

            // Orders From
            if (this.tableFilter.ordersFrom !== '') {
                options = {
                    ...options,
                    ordered_on_gte:
                        this.tableFilter.ordersFrom + '+00%3A00%3A00&',
                };
            }

            // Orders To
            if (this.tableFilter.ordersTo !== '') {
                options = {
                    ...options,
                    ordered_on_lte:
                        this.tableFilter.ordersTo + '+00%3A00%3A00&',
                };
            }

            return options;
        },

        handleCurrentPage(query) {
            if (query && query.page) {
                this.page = parseInt(query.page);
            } else {
                this.page = 1;
            }
        },

        resetFilterOptions() {
            this.showFilterOrderDates = false;
            this.showFilterStatus = false;
        },

        showFilterOptions() {
            this.resetFilterOptions();

            if (this.config.showColumnFilter) {
                this.config.showColumnFilter.forEach((filter) => {
                    switch (filter) {
                        case 'ordered_on':
                            this.showFilterOrderDates =
                                this.showFilterOrderDates === false
                                    ? ''
                                    : this.showFilterOrderDates;
                            break;
                        case 'status':
                            this.showFilterStatus = this.tableFilter.status;
                            break;
                        default:
                            break;
                    }
                });
            }
        },

        onStatusChange(eventStatus) {
            this.showFilterStatus = eventStatus === 'all' ? '' : eventStatus;
        },

        resetForm(formName) {
            this.$refs['tableFilter'].resetFields();

            this.tableFilter = Object.assign(this.tableFilter, {
                country_id: '',
                status: '',
                ordersFrom: '',
                ordersTo: '',
                origin_id: '',
            });

            this.tableFilterVisible = false;
            storage.removeItem(storage.keys.TABLE_FILTER);

            this.showFilterOptions();
            this.loadData();
        },

        filterSearch() {
            this.pageChange(1);

            this.tableFilterVisible = false;
            storage.setItem(storage.keys.TABLE_FILTER, this.tableFilter);

            this.loadData();
        },

        getHeader(res, header) {
            if (res.headers.map[header]) {
                return parseInt(res.headers.map[header][0]);
            }
            let lowerHeader = header.toLowerCase();
            if (res.headers.map[lowerHeader]) {
                return parseInt(res.headers.map[lowerHeader][0]);
            }
            return 0;
        },

        setTableData(res) {
            this.pageSize = this.getHeader(res, 'Per-Page');
            this.numFound = this.getHeader(res, 'Total');

            if (this.config.rootObject) {
                this.tableData = res.body[this.config.rootObject];
            } else {
                this.tableData = res.body;
            }

            if (this.config.route === 'categories') {
                this.nestCategoriesHierarchy();
                this.mapCategoriesHierarchy();
            }

            this.loading = false;

            this.showFilterOptions();
        },

        nestCategoriesHierarchy() {
            let result = [];
            if (this.tableData.length) {
                this.tableData.forEach((category) => {
                    category.children = [];
                });
                let root = {};
                let map = new Map(this.tableData.map((o) => [o.id, { ...o }]));
                map.forEach((o) =>
                    ((p) => (p.children = (p.children || []).concat(o)))(
                        map.get(o.parent_id) || root
                    )
                );
                result = root.children;
            }
            this.nestedTableData = result;
        },

        mapCategoriesHierarchy() {
            this.tableData = this.recursiveCategory(-1, [], 0);
        },

        recursiveCategory(i, data, parentId) {
            const childData = this.tableData.filter(
                (e) => e.parent_id === parentId
            );
            if (childData) {
                i++;
                childData.forEach((e) => {
                    if (i > 0) {
                        let element = ['', '→', '»', '◦'];
                        e.name =
                            Array(4 * i)
                                .fill('\xa0')
                                .join('') +
                            (element[i] || '→') +
                            ' ' +
                            e.name;
                    }
                    data.push(e);
                    data = this.recursiveCategory(i, data, e.id);
                });
            }
            return data;
        },

        handleRowClick(row, column, event) {
            const currentTextSelection = window.getSelection().toString();
            if (event.type === 'click' && currentTextSelection.length === 0) {
                if (
                    (column.property === 'customer_name' ||
                        column.property === 'email') &&
                    this.isOrdersRoute() &&
                    this.isVisible
                ) {
                    this.$router.push({
                        name: 'admin',
                        params: {
                            id: row.customer_id,
                            action: 'edit',
                            model: 'customers',
                        },
                    });
                    return;
                }
                this.$router.push({
                    name: 'admin',
                    params: {
                        id: row.id || row.uuid,
                        action: 'edit',
                        model: this.config.route,
                    },
                });
            }
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        massDeletion() {
            this.multipleSelection.forEach((item, index) => {
                setTimeout(() => {
                    this.apiResource
                        .delete({ id: item.id }, null)
                        .then(() => {
                            this.loadData();
                        })
                        .catch(api.errorHandler);
                }, 200 * index);
            });
        },

        getFilterLabel(key) {
            switch (key) {
                case 'status':
                    return 'Filter status';
                case 'ordersFrom':
                    return 'Orders From';
                case 'ordersTo':
                    return 'Orders To';
                case 'country_id':
                    return 'Filter country';
                case 'origin_id':
                    return 'Filter origin';
            }
        },

        getFilterCountryName(value) {
            if (this.activeCountries.length) {
                const country = this.activeCountries.filter(
                    (ac) => ac.country_id === value
                );
                return country[0].name;
            }
        },

        getFilterOriginName(value) {
            if (this.origins.length) {
                const origin = this.origins.filter((o) => o.id === value);
                return origin[0].name;
            }
        },

        refresh() {
            this.loadData();
        },

        isBrUser() {
            return this.userRole === 'BRAdmin';
        },

        isUkUser() {
            return this.userRole === 'UKAdmin';
        },

        isUsUser() {
            return this.userRole === 'USAdmin';
        },

        isCustomerSupport() {
            return this.userRole === 'CustomerSup';
        },
    },
};
</script>

<style>
.footer {
    padding: 30px 0;
    text-align: center;
}

.selection {
    margin-bottom: 20px;
}

.selection__button {
    margin-right: 15px;
    display: inline-block;
}

.selection__text {
    display: inline-block;
}

.header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.title {
    margin-right: auto;
    font-size: 1.2rem;
}

.buttons {
    margin-left: auto;
}

.upload-btn {
    position: relative;
}

.upload-btn > * {
    display: inline-block;
}

.buttons > * {
    margin-left: 10px !important;
    display: inline-block;
}

.buttons .el-upload-list {
    position: absolute;
    background: #fff;
    z-index: 10001;
    border-radius: 5px;
    margin-top: 5px;
    right: 0;
    border: 1px solid #ccc;
}

.buttons .el-upload-list__item:first-child {
    margin-top: 0;
}

.el-popover .el-date-editor,
.el-popover .el-select {
    width: 100%;
}

.el-tag {
    margin-left: 10px;
}

.el-checkbox-group {
    margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// VueCrudIndex.vue?2dcbccb8